import { __decorate } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCTokenComponent = class UiCTokenComponent {
    constructor() {
        this.onChange = new EventEmitter();
        this.clickEvt = new EventEmitter();
        this.keyUpEvt = new EventEmitter();
    }
    ngOnInit() { }
    onChangeForm() {
        this.onChange.emit(this.formToken);
    }
    onKey() {
        this.keyUpEvt.emit();
    }
    confirm() {
        this.clickEvt.emit();
    }
};
__decorate([
    Input()
], UiCTokenComponent.prototype, "formToken", void 0);
__decorate([
    Input()
], UiCTokenComponent.prototype, "errorMessages", void 0);
__decorate([
    Input()
], UiCTokenComponent.prototype, "buttonText", void 0);
__decorate([
    Input()
], UiCTokenComponent.prototype, "errorToken", void 0);
__decorate([
    Input()
], UiCTokenComponent.prototype, "loading", void 0);
__decorate([
    Output()
], UiCTokenComponent.prototype, "onChange", void 0);
__decorate([
    Output()
], UiCTokenComponent.prototype, "clickEvt", void 0);
__decorate([
    Output()
], UiCTokenComponent.prototype, "keyUpEvt", void 0);
UiCTokenComponent = __decorate([
    Component({
        selector: 'ui-c-token',
        template: "<div class=\"token-component\">\n  <form [formGroup]=\"formToken\" (change)=\"onChangeForm()\">\n    <p class=\"ion-text font-size-14\">\n      {{'CASH_OUT.MODAL_TOKEN.DESCRIPTION' | wlpTranslate}}\n    </p>\n    <div class=\"details\">\n      <ion-col size=\"12\">\n        <div class=\"detail-item\">\n          <div class=\"div-token\">\n            <ion-item class=\"ion-item mx-4\">\n              <ion-input (change)=\"$event.target.value = $event.target.value.toUpperCase()\"  formControlName=\"token\" type=\"text\" class=\"token\" placeholder=\"{{ 'CASH_OUT.MODAL_TOKEN.PLACEHOLDER' | wlpTranslate }}\" maxlength=\"100\"\n                (keyup)=\"onKey()\">\n              </ion-input>\n            </ion-item>\n          </div>\n          <div class=\"error-messages\">\n            <ng-container *ngFor=\"let error of errorMessages.token\">\n              <div class=\"error-message\"\n                *ngIf=\"formToken.get('token').hasError(error.type) && (formToken.get('token').dirty || formToken.get('token').touched)\">\n                {{error.message}}\n              </div>\n            </ng-container>\n            <ng-container *ngIf=\"errorToken\">\n              <div class=\"error-message\">\n                {{errorToken | wlpTranslate}}\n              </div>\n            </ng-container>\n          </div>\n        </div>\n        <div class=\"group-buttons-token\" *ngIf=\"!loading\">\n          <div class=\"container\">\n            <ion-col class=\"ion-col ion-padding-vertical\">\n              <ui-c-button expand=\"block\" (continue)=\"confirm()\">{{buttonText}}</ui-c-button>\n            </ion-col>\n          </div>\n        </div>\n        <ion-row class=\"ion-justify-content-center ion-align-items-center\" *ngIf=\"loading\">\n          <div class=\"loaging\">\n            <ion-spinner class=\"ion-spinner\" name=\"lines\" color=\"secondary\"></ion-spinner>\n          </div>\n        </ion-row>\n      </ion-col>\n    </div>\n  </form>\n</div>\n",
        styles: [""]
    })
], UiCTokenComponent);

let UiCTokenModule = class UiCTokenModule {
};
UiCTokenModule = __decorate([
    NgModule({
        declarations: [UiCTokenComponent],
        imports: [
            IonicModule,
            CommonModule,
            ReactiveFormsModule,
            UiCButtonModule,
            UiBsTranslateModule
        ],
        exports: [UiCTokenComponent]
    })
], UiCTokenModule);

/*
 * Public API Surface of ui-c-token
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCTokenComponent, UiCTokenModule };
//# sourceMappingURL=wlp-ui-c-token.js.map
